export const handleToggleVisibility = (elements, state = 'hide') => {
    if(typeof(elements) != 'undefined') {
        if(state === 'hide') {
            elements.forEach(e=> {
                e.classList.add('hidden')
            })
        } else {
            elements.forEach(e=> {
                e.classList.remove('hidden')
            })
        }
    }
}

export const countDisjunctiveFacetsRefinements = (refinements) => {
    const array = Object.keys(refinements);
    let hasLength = false;
    array.some((e) => {
        if(refinements[e].length > 0) {
            hasLength = true;
        }
    })
    return hasLength;
}